import { API_URL } from '@/lib/apiConfig';
import { createClient as createCustomClient } from './customClient';


function getToken() {
  return localStorage.getItem('token');
}

export const api = createCustomClient({ apiUrl: API_URL, token: getToken() });
